// extracted by mini-css-extract-plugin
export default {"notificationPlayground":"notificationPlayground-v6513","contents":"contents-nHWph","item":"item-TWP7b","label":"label-lHW4J"};